import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Icons.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "icons" },
    [
      _vm.isFetching
        ? _c("Spinner", {
            staticClass: "spinner-icon",
            attrs: { size: "icon" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowClearIcon
        ? _c("Clear", {
            staticClass: "clear-icon",
            attrs: { size: "xsmall", "primary-color": "#A5ADBA" },
            nativeOn: {
              click: function($event) {
                return _vm.onClear($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", [
        !_vm.createable ? _c("Caret", { attrs: { size: "xsmall" } }) : _vm._e()
      ])
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-32124c66";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/Icons.vue.js